"use client";

import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import hasFadeAnim from "@/lib/animation/hasFadeAnim";
import hasTextMovAnim from "@/lib/animation/hasTextMovAnim";
import hasCharAnim from "@/lib/animation/hasCharAnim";

type Props = {
  paragraphs?: string[];
};

const WhoWeAreAbout = ({
  paragraphs = [],
}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null!);

  useGSAP(
    () => {
      hasFadeAnim();
      hasTextMovAnim();
      hasCharAnim();
    },
    { scope: containerRef },
  );

  return (
    <section
      className="relative w-full bg-white text-black section-spacing-top sm:overflow-hidden"
      ref={containerRef}
    >
      {/* <section className="relative w-full bg-white text-black section-spacing-top pb-[60px] md:pb-0 sm:overflow-hidden"> */}
      {/* {map_src && (
        <div
          className="absolute inset-0 pointer-events-none select-none"
          aria-hidden="true"
        >
          <div
            className="absolute inset-0 z-[1]
            bg-gradient-to-b from-white via-white/90 to-white/20
            md:bg-gradient-to-r md:from-white md:via-white/85 md:to-white/10
          "
          />
          <div
            className="absolute inset-0 z-[1] hidden md:block
            bg-gradient-to-l from-white/60 via-transparent to-transparent
          "
          />
          <div
            className="absolute inset-0 z-[1] hidden md:block
            bg-gradient-to-b from-white/50 via-transparent to-white/50
          "
          />
          <div
            className="
            absolute opacity-[0.30]
            bottom-[-5%] left-1/2 -translate-x-1/2 w-[130%]
            md:bottom-auto md:left-auto md:translate-x-0
            md:right-[15%] md:top-1/2 lg:top-2/3 md:-translate-y-1/2 md:w-[68%]
            lg:w-[33%]
          "
          >
            <Image
              src={map_src}
              alt={map_alt}
              width={1200}
              height={600}
              className="w-full h-auto object-contain"
              priority
            />
          </div>
        </div>
      )} */}

      {/* Konten utama */}
      <div className="relative z-[2] inner-container-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 lg:gap-24">
          {/* Kolom Kiri — paragraf dari MDX */}
          <div className="flex flex-col gap-8 md:gap-10">
            {paragraphs.map((para, i) => (
              <div
                key={i}
                className="has_fade_anim text-[20px] sm:text-[22px] lg:text-[24px] leading-relaxed text-black/90 text-justify font-light
                [&_p]:text-[20px] sm:[&_p]:text-[22px] lg:[&_p]:text-[24px]
                [&_p]:leading-relaxed
                [&_p]:mb-6 [&_p:last-child]:mb-0
                [&_h1]:font-semibold [&_h1]:mb-4
                [&_h2]:font-semibold [&_h2]:mb-3
                [&_h3]:font-semibold [&_h3]:mb-3
                [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-3
                [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-3
                [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:bg-black/10
                [&_a]:underline [&_a]:underline-offset-4"
                data-fade-from="bottom"
                data-fade-offset="20"
                data-delay={0.1 + i * 0.15}
                data-duration="0.8"
                data-on-scroll="0"
                dangerouslySetInnerHTML={{ __html: para }}
              />
            ))}
          </div>

          {/* Kolom Kanan — paragraf */}
          {/* <div className="flex flex-col gap-8 md:gap-10">
            {right_paragraph && (
              <p className="text-[20px] sm:text-[22px] lg:text-[24px] leading-relaxed text-black/90 text-justify font-light">
                {right_paragraph}
              </p>
            )}
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default WhoWeAreAbout;
